module.exports = __webpack_public_path__ + "media/assets/decreasing-406a3e4740a64b5559e3225100f0aae6.svg";